import React, { useState } from "react";
import TextField from "@mui/material/TextField";
import "dayjs/locale/ko";
import dayjs from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { red } from "@mui/material/colors";

const DateCalender = ({
  required = false,
  width = 160,
  autoComplete = "off",
  disabled = false,
  label,
  value,
  name,
  readOnly = false,
  id,
  validation,
  fontSize,
  paddingLeft,
  paddingRight,
  onChange,
}) => {
  // eslint-disable-next-line
  const [dateErr, setDateErr] = useState("");

  const setLabDateError = (err, val) => {
    if (val === null || err === "") {
      setDateErr("");
    } else {
      setDateErr(err);
      if (typeof name !== "undefined" && typeof onChange === "function") {
        if (err === "invalidDate") {
          onChange({
            target: { value: "", name },
          });
        }
      }
    }
  };

  const handleChange = (newValue) => {
    if (typeof name !== "undefined" && typeof onChange === "function") {
      onChange({
        target: {
          value: newValue
            ? dayjs(newValue).format("YYYYMMDD")
            : null,
          name,
        },
      });
    }
  };

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale="ko"
    >
      <DatePicker
        required={required}
        label={label}
        value={value}
        name={name}
        disabled={disabled}
        readOnly={readOnly}
        onChange={handleChange}
        renderInput={(params) => (
          <TextField
            {...params}
            id={id}
            error={!!validation}
            required={required}
            size="small"
            autoComplete={autoComplete}
            helperText={validation}
            FormHelperTextProps={{ style: { color: "#d32f2f" } }}
            InputLabelProps={{
              style: {
                fontSize: "13px",
                color: required ? "#fa0505" : "#000000",
              },
            }}
            sx={
              required
                ? !validation
                  ? {
                      m: 1,
                      width,
                      "& .MuiInputLabel-root": { color: red[600] },
                      "& .MuiInputLabel-root.Mui-focused": { color: red[600] },
                      "& .MuiInputBase-input": {
                        fontSize: "14px",
                        paddingLeft: "10px",
                        paddingRight: "8px",
                      },
                    }
                  : {
                      m: 1,
                      width,
                      "& .MuiInputLabel-root": { color: red[600] },
                      "& .MuiInputLabel-root.Mui-focused": { color: red[600] },
                      "& .MuiInputBase-input": {
                        fontSize: fontSize ?? "14px",
                        paddingLeft: paddingLeft ?? "10px",
                        paddingRight: paddingRight ?? "8px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": {
                        borderColor: "#d32f2f",
                      },
                    }
                : {
                    m: 1,
                    width,
                    "& .MuiInputBase-input": {
                      fontSize: fontSize ?? "14px",
                      paddingLeft: paddingLeft ?? "10px",
                      paddingRight: paddingRight ?? "8px",
                    },
                  }
            }
          />
        )}
        onError={setLabDateError}
      />
    </LocalizationProvider>
  );
};

export default React.memo(DateCalender);
